// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3l_LU","comment":"styles_comment__2v7Jl"};